import { createTheme } from '@mui/material/styles';

const serif = '"Playfair Display", Georgia, serif';

// MUI defaults for public pages, matching the gold Ivory Luxe design.
export const theme = createTheme({
  palette: {
    primary: { main: '#aa8238', light: '#c7a45d', dark: '#8f6729', contrastText: '#fff' },
    secondary: { main: '#252018' },
    text: { primary: '#211d18', secondary: '#756f65' },
    background: { default: '#fffdf8', paper: '#ffffff' },
  },
  typography: {
    fontFamily: '"DM Sans", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: { fontFamily: serif, fontWeight: 500 },
    h2: { fontFamily: serif, fontWeight: 500 },
    h3: { fontFamily: serif, fontWeight: 500 },
    h4: { fontFamily: serif, fontWeight: 500 },
    h5: { fontFamily: serif, fontWeight: 500 },
    button: { textTransform: 'none', fontWeight: 700 },
  },
});
